import bronze from "../../assets/Rank Badges/bronze.png";
import copper from "../../assets/Rank Badges/copper.png";
import Silver from "../../assets/Rank Badges/silver.png";
import Electrum from "../../assets/Rank Badges/electrum.png";
import Gold from "../../assets/Rank Badges/gold.png";
import Platinum from "../../assets/Rank Badges/platinum.png";
import Diamond from "../../assets/Rank Badges/diamond.png";
import Diamond_Pollinated from "../../assets/Rank Badges/daimond pollinated.png";
import Carpenter from "../../assets/Rank Badges/carpenter.png";
import Carpenter_Pollinated from "../../assets/Rank Badges/carpenter pollinated.png";
import Hornet from "../../assets/Rank Badges/hornet.png";
import Hrnet_pollinated from "../../assets/Rank Badges/hornet pollinated.png";
import Wasp from "../../assets/Rank Badges/wasp.png";
import Wasp_Pollinated from "../../assets/Rank Badges/wasp pollinated.png";
import Royal from "../../assets/Rank Badges/royal.png";
import Royal_Pollinated from "../../assets/Rank Badges/royal_pollinated.png";


export const RankData = [
    {
        id: "1",
        name: "Bronze",
        photo: bronze,
    },
    {
        id: "2",
        name: "Copper",
        photo: copper,
    },
    {
        id: "3",
        name: "Silver",
        photo: Silver,
    },
    {
        id: "4",
        name: "Electrum",
        photo: Electrum,
    },
    {
        id: "5",
        name: "Golden",
        photo: Gold,
    },
    {
        id: "6",
        name: "Platinum",
        photo: Platinum,
    },
    {
        id: "7",
        name: "Diamond",
        photo: Diamond,
    },
    {
        id: "8",
        name: "Pollinated Diamond Rank",
        photo: Diamond_Pollinated,
    },
    {
        id: "9",
        name: "Carpenter Rank",
        photo: Carpenter,
    },
    {
        id: "10",
        name: "Pollinated Carpenter Rank",
        photo: Carpenter_Pollinated,
    },
    {
        id: "11",
        name: "Wasp Rank",
        photo: Wasp,
    },
    {
        id: "12",
        name: "Pollinated Wasp Rank",
        photo: Wasp_Pollinated,
    },
    {
        id: "13",
        name: "Hornet Rank",
        photo: Hornet,
    },
    {
        id: "14",
        name: "Pollinated Hornet Rank",
        photo: Hrnet_pollinated,
    },
    {
        id: "15",
        name: "Royal Rank",
        photo: Royal,
    },
    {
        id: "16",
        name: "Pollinated Royal Rank",
        photo: Royal_Pollinated,
    },
]